import { isAdminOrAbove } from './roles';

export function hasFullStudentDetailAccess(role) {
  return isAdminOrAbove(role);
}

export function maskEmail(email) {
  if (!email || typeof email !== 'string') return '••••••••';
  const [local, domain] = email.split('@');
  if (!domain) return '••••••••';
  const safeLocal = local.length <= 1 ? '•' : `${local[0]}***`;
  return `${safeLocal}@${domain}`;
}

export function maskPhone(phone) {
  if (!phone || typeof phone !== 'string') return '••••••••';
  const digits = phone.replace(/\D/g, '');
  if (digits.length < 4) return '••••';
  return `••••••${digits.slice(-4)}`;
}

export function maskStudentNumber(num) {
  if (!num || typeof num !== 'string') return '••••••••';
  if (num.length <= 8) return '••••••••';
  return `${num.slice(0, 4)}••••••${num.slice(-4)}`;
}

export function maskLocation(country, town) {
  const c = country || '';
  const t = town || '';
  if (!c && !t) return 'Restricted';
  if (c && !t) return `${c.slice(0, 2)}••`;
  if (!c && t) return `${t.slice(0, 1)}••`;
  return `${c.slice(0, 2)}••, ${t.slice(0, 1)}••`;
}
